import { render, staticRenderFns } from "./CourseClassWeekSchedule.vue?vue&type=template&id=69a94d47&scoped=true"
import script from "./CourseClassWeekSchedule.vue?vue&type=script&lang=js"
export * from "./CourseClassWeekSchedule.vue?vue&type=script&lang=js"
import style0 from "./CourseClassWeekSchedule.vue?vue&type=style&index=0&id=69a94d47&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a94d47",
  null
  
)

export default component.exports